module.exports = __webpack_public_path__ + "img/diedai.62a58500.png";